import { getRoute } from '../../../packages/context/index.ts';

export function useAppController() {
  const {
    main: { charity },
  } = getRoute();

  return { charity: charity() };
}
